module.exports = __webpack_public_path__ + "wojciech-bf2a5acd3de891479d81413ea8d8fd05.webp";